import { render } from "./DraggableNested.vue?vue&type=template&id=46b20fc1"
import script from "./DraggableNested.vue?vue&type=script&lang=js"
export * from "./DraggableNested.vue?vue&type=script&lang=js"

import "./DraggableNested.vue?vue&type=style&index=0&id=46b20fc1&lang=css"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__